import { ROUTE_WE_SPIN } from '../../../router/constants.js';

export const ROUTE_WE_SPIN_GAME_VIEW = `${ROUTE_WE_SPIN}/game-view`;
export const ROUTE_WE_SPIN_LOBBY = `${ROUTE_WE_SPIN}`;
export const ROUTE_WE_SPIN_GAME_ROOM = 'we-spin-game-room';

export const ROUTE_WE_SPIN_GAME_ROOM_ABS = `/${ROUTE_WE_SPIN_GAME_ROOM}`; // for sidebar
export const ROUTE_WE_SPIN_GAME_ROOM_TOC = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/terms-and-conditions`;
export const ROUTE_WE_SPIN_GAME_ROOM_TIP = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/tip`;
export const ROUTE_WE_SPIN_GAME_ROOM_STREAMER = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/streamer`;
export const ROUTE_WE_SPIN_GAME_ROOM_CHAT = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/chat`;
export const ROUTE_WE_SPIN_GAME_ROOM_ENDED = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/ended`;
export const ROUTE_WE_SPIN_GAME_ROOM_CANCELLED = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/cancelled`;
export const ROUTE_WE_SPIN_GAME_ROOM_PREVIEW = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/preview`;
export const ROUTE_WE_SPIN_GAME_ROOM_BUY_IN = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/buy-in`;
export const ROUTE_WE_SPIN_GAME_ROOM_BUY_IN_SUCCESS = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/success-buy-in`;
export const ROUTE_WE_SPIN_GAME_ROOM_SPECTATOR = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/spectator`;
export const ROUTE_WE_SPIN_GAME_ROOM_RULES = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/rules`;
export const ROUTE_WE_SPIN_GAME_ROOM_EVENT_NOT_FOUND = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/not-found`;
export const ROUTE_WE_SPIN_GAME_ROOM_LIST_PLAYERS = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/players`;
export const ROUTE_WE_SPIN_GAME_ROOM_LIST_RAFFLE = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/raffle`;
export const ROUTE_WE_SPIN_GAME_ROOM_LIST_GAMES = `${ROUTE_WE_SPIN_GAME_ROOM_ABS}/games`;

export const ROUTE_WE_SPIN_GAME_ROOM_ALL = [
	ROUTE_WE_SPIN_GAME_ROOM_TIP,
	ROUTE_WE_SPIN_GAME_ROOM_STREAMER,
	ROUTE_WE_SPIN_GAME_ROOM_CHAT,
	ROUTE_WE_SPIN_GAME_ROOM_ENDED,
	ROUTE_WE_SPIN_GAME_ROOM_CANCELLED,
	ROUTE_WE_SPIN_GAME_ROOM_PREVIEW,
	ROUTE_WE_SPIN_GAME_ROOM_BUY_IN,
	ROUTE_WE_SPIN_GAME_ROOM_BUY_IN_SUCCESS,
	ROUTE_WE_SPIN_GAME_ROOM_SPECTATOR,
	ROUTE_WE_SPIN_GAME_ROOM_RULES,
	ROUTE_WE_SPIN_GAME_ROOM_TOC,
	ROUTE_WE_SPIN_GAME_ROOM_EVENT_NOT_FOUND,
	ROUTE_WE_SPIN_GAME_ROOM_LIST_PLAYERS,
	ROUTE_WE_SPIN_GAME_ROOM_LIST_RAFFLE,
	ROUTE_WE_SPIN_GAME_ROOM_LIST_GAMES
];

export const ROUTE_WE_SPIN_GAME_ROOM_ALL_WITH_PARAM = ROUTE_WE_SPIN_GAME_ROOM_ALL.map(path => `${path}/:ref`);

export const ROUTE_ACCOUNT_WE_SPIN_CREATE_PROFILE = '/account/we-spin-create-profile';

export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD = '/account/we-spin-dashboard';
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/createSession`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION_GAMES_LIST = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION}/games`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION_SUCCESS = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/createSession/success`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_VIEW_DETAILS = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/viewDetails`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_EDIT_SESSION = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/editSession`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SCHEDULED_SESSIONS = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/scheduled`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_UPCOMING_SESSIONS = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/scheduled/upcoming`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_PAST_SESSIONS = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/scheduled/past`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SETTINGS = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/settings`;

export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_LIVE = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/live`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_BONUS_BOOST = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/bonusBoost`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SEARCH = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/search`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CHAT = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/chat`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_TWITCH_AUTH = `${ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}/twitchAuth`;
export const ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_ALL = [
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CREATE_SESSION,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SCHEDULED_SESSIONS,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_UPCOMING_SESSIONS,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_PAST_SESSIONS,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SETTINGS,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_LIVE,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_SEARCH,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_CHAT,
	ROUTE_ACCOUNT_WE_SPIN_DASHBOARD_TWITCH_AUTH
];
